export default "__VITE_ASSET__1b485814__"